import { gql, type TypedDocumentNode } from '@apollo/client'

export type GlobalSearchResultItem = {
  id: string
  domain: string
  description: string
  entityType: string
  score: number
}

export type GlobalSearchDomainResultsPage = {
  domain: string
  content: GlobalSearchResultItem[]
  pageInfo: {
    totalElements: number
  }
}

export type GlobalSearchResponse = {
  globalSearch: {
    results: GlobalSearchDomainResultsPage[]
  }
}

export type GlobalTopLevelSearchResponse = {
  globalTopLevelSearch: {
    results: GlobalSearchDomainResultsPage[]
  }
}

export type GlobalSearchVariables = {
  domain: string
  page: number
  searchText: string
  size: number
}

export type GlobalTopLevelSearchVariables = {
  page: number
  searchText: string
  size: number
}

export const FEDERATED_GET_GLOBAL_SEARCHES: TypedDocumentNode<
  GlobalSearchResponse,
  GlobalSearchVariables
> = gql`
  query getGlobalSearches(
    $domain: GlobalSearchDomain!
    $page: Int!
    $searchText: String!
    $size: Int!
  ) {
    globalSearch(
      domain: $domain
      page: $page
      searchText: $searchText
      size: $size
    ) {
      results {
        domain
        content {
          description
          domain
          entityType
          id
          score
        }
        pageInfo {
          totalElements
        }
      }
    }
  }
`

export const FEDERATED_GET_GLOBAL_TOP_LEVEL_SEARCHES: TypedDocumentNode<
  GlobalTopLevelSearchResponse,
  GlobalTopLevelSearchVariables
> = gql`
  query getGlobalTopLevelSearch(
    $page: Int!
    $searchText: String!
    $size: Int!
  ) {
    globalTopLevelSearch(page: $page, searchText: $searchText, size: $size) {
      results {
        content {
          description
          domain
          entityType
          id
          score
        }
        pageInfo {
          totalElements
        }
      }
    }
  }
`
